<template>
    <div class="main-content">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h5>Брони препаратов</h5>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-4">
                                <StoreSelect/>
                            </div>
                            <div class="col-md-8">
                                <vue-ladda @click="showReserve()" button-class="btn btn-info"
                                           data-style="zoom-in"
                                           :loading="btn_loading">Показать брони
                                </vue-ladda>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <table class="table table-hover table-bordered">
                            <thead>
                            <tr>
                                <th></th>
                                <th>Препарат</th>
                                <th>Бронь</th>
                                <th>Морион</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(prep, index) in orderedPrepNames(prep_names)" :key="index">
                                <td>{{index+1}}</td>
                                <td>{{prep.name}}</td>
                                <td>
                                    <div v-html="printReserve(prep.id)"/>
                                </td>
                                <td>{{prep.id}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '@/api'
    import StoreSelect from '@/views/admin/components/StoreSelect'
    import VueLadda from 'vue-ladda/src/vue-ladda.vue'

    export default {
        components: {
            StoreSelect,
            VueLadda,
        },
        data() {
            return {
                btn_loading: false,
                selected_store: null,
                store_name: null,
                prep_names: {},
                requests: {},
                store_names: {}
            }
        },
        methods: {
            printReserve(prepId) {
                let keys = Object.keys(this.requests);
                let reserve = '';
                keys.forEach((key) => {
                    console.log(key);
                    if (this.requests[key].preps_w_orders.urgent && this.requests[key].preps_w_orders.urgent[prepId]) {
                        reserve += '<p class="m-b-2">' + this.store_names[key].short_name + ' - Срочные:</p>';
                        Object.keys(this.requests[key].preps_w_orders.urgent[prepId]).forEach((orderId) => {
                            reserve += '<p class="m-b-2">' + orderId + ' => ' + this.requests[key].preps_w_orders.urgent[prepId][orderId] + '</p>';
                        })
                    }
                    if (this.requests[key].preps_w_orders.regular && this.requests[key].preps_w_orders.regular[prepId]) {
                        reserve += '<p>' + this.store_names[key].short_name + ' - Обычные:</p>';
                        Object.keys(this.requests[key].preps_w_orders.regular[prepId]).forEach((orderId) => {
                            reserve += '<p>' + orderId + ' => ' + this.requests[key].preps_w_orders.regular[prepId][orderId] + '</p>';
                        })
                    }
                })
                return reserve;
            },
            orderedPrepNames: function (preps, request = false) {
                let sorted = _.orderBy(preps, 'name')
                if (request) {
                    sorted = sorted.filter(x => request[x.id])
                }
                return sorted
            },
            async showReserve() {
                this.btn_loading = true
                const {data} = await api.store('/autolists/getPrepsInReserve', {
                    store_id: this.selected_store
                })
                this.requests = data.requests
                this.prep_names = data.prep_names
                this.store_names[4] = {short_name: 'ПС'}
                this.btn_loading = false
            }
        }
    }

</script>

<style scoped>
    table.table td{
        padding: 2px;
    }
    table.table td p{
        margin-bottom: 2px;
    }
</style>